import { useEffect, useRef } from "react";
import { X, ListTree } from "lucide-react";

export const currentChapterIndex = (chapters, page) => {
  let idx = -1;
  chapters.forEach((c, i) => {
    if (c.page <= page) idx = i;
  });
  return idx;
};

export default function ChapterDrawer({ chapters, page, onPick, onClose }) {
  const current = currentChapterIndex(chapters, page);
  const activeRef = useRef(null);
  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: "center" });
  }, []);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-50 flex justify-end" data-testid="chapter-drawer">
      <button className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} aria-label="Close chapters" />
      <aside className="relative w-full max-w-sm h-full bg-[#0F1014] border-l border-white/10 flex flex-col fade-up">
        <div className="flex items-center justify-between px-6 h-16 border-b border-white/10 shrink-0">
          <p className="flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.2em] text-primary-gold">
            <ListTree className="w-4 h-4" /> Chapters
          </p>
          <button onClick={onClose} className="text-soft hover:text-text-primary" data-testid="chapter-drawer-close" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>
        {chapters.length === 0 ? (
          <p className="p-6 text-soft text-sm" data-testid="chapter-list-empty">
            No chapter headings were found in this book. Use the page number box to jump around.
          </p>
        ) : (
          <ol className="overflow-y-auto py-3" data-testid="chapter-list">
            {chapters.map((c, i) => (
              <li key={`${c.page}-${i}`}>
                <button
                  ref={i === current ? activeRef : null}
                  onClick={() => onPick(c.page)}
                  data-testid={`chapter-item-${c.page}`}
                  className={`w-full text-left flex items-baseline gap-4 px-6 py-3 transition-colors hover:bg-white/5 ${
                    i === current ? "text-primary-gold bg-primary-gold/5 border-l-2 border-primary-gold" : "text-text-primary border-l-2 border-transparent"
                  }`}
                >
                  <span className="font-serif-display text-lg leading-snug flex-1">{c.title}</span>
                  <span className="font-mono-ui text-[10px] text-soft shrink-0">p. {c.page}</span>
                </button>
              </li>
            ))}
          </ol>
        )}
      </aside>
    </div>
  );
}
